import {
  yandexMaps
} from "../../../mixins/yandex-maps.js";

import {
  userCoords
} from "../../../mixins/user-coords.js";

import {
  MapParam,
  PlacemarkOption,
  ActionType
} from "../const.js";

export default class OrderMap {
  constructor(container, formModel) {
    this._container = container;
    this._formModel = formModel;

    this._zoom = MapParam.ZOOM;
    this._iconUrl = MapParam.ICON.URL;
    this._iconSize = MapParam.ICON.SIZE;
    this._iconRealSize = MapParam.ICON.REAL_SIZE;

    this._placemark = null;

    this._renderMap = this._renderMap.bind(this);
    this._processRenderMap = this._processRenderMap.bind(this);
    this._mapClickHandler = this._mapClickHandler.bind(this);
  }

  init() {
    this.loadScript(this._renderMap);
  }

  _renderMap() {
    this._ymaps = window.ymaps;
    this._ymaps.ready(() => {
      this.getCoords(this._processRenderMap);
    });
  }

  _getAddress(coords) {
    this._ymaps.geocode(coords)
      .then(
          (result) => {
            const firstGeoObject = result.geoObjects.get(0);
            const address = firstGeoObject.getAddressLine();

            this._formModel.changeData(Object.assign(
                {},
                this._formModel.getData(),
                {
                  addressShipping: address
                }
            ), ActionType.SET_PLACEMARK);
          },
          (error) => {
            console.error(`Ошибка получения адреса доставки по координатам клика на карте. Ошибка: ${error}`);

            this._formModel.changeData(Object.assign(
                {},
                this._formModel.getData(),
                {
                  addressShipping: ``
                }
            ), ActionType.SET_PLACEMARK);
          }
      );
  }

  _processRenderMap() {
    this._map = new this._ymaps.Map(
        this._container,
        {
          center: this._coords,
          zoom: this._zoom,
          controls: {}
        },
        {
          suppressMapOpenBlock: true
        }
    );

    this._map.behaviors.disable([`dblClickZoom`]);
    this.setCopyrightsStyle();

    this._setMapClickHandler();
  }

  _setMapClickHandler() {
    this._map.events.add(`click`, this._mapClickHandler);
  }

  _mapClickHandler(evt) {
    const coords = evt.get(`coords`);

    if (this._placemark) {
      this._placemark.geometry.setCoordinates(coords);
    } else {
      this._placemark = this.createPlacemark(coords, Object.assign(
          {},
          PlacemarkOption
      ));
    }

    this._getAddress(coords);
  }
}

Object.assign(OrderMap.prototype, yandexMaps);
Object.assign(OrderMap.prototype, userCoords);
